import { Proving } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Section } from 'views/ProvingDetailsView/Layout'

export const DataStorageLabelSwitcher: React.FC<{
  params: string
  proving: Proving
}> = ({ params, proving }) => {
  const { t } = useTranslation()

  let blockNote = ''

  switch (params) {
    case 'block1':
      blockNote =
        proving.provingGround && proving.provingGround.block1Note
          ? proving.provingGround.block1Note
          : ''
      break
    case 'block2':
      blockNote =
        proving.provingGround && proving.provingGround.block2Note
          ? proving.provingGround.block2Note
          : ''
      break
    case 'block3':
      blockNote =
        proving.provingGround && proving.provingGround.block3Note
          ? proving.provingGround.block3Note
          : ''
      break
    case 'block4':
      blockNote =
        proving.provingGround && proving.provingGround.block4Note
          ? proving.provingGround.block4Note
          : ''
      break
    case 'block5':
      blockNote =
        proving.provingGround && proving.provingGround.block5Note
          ? proving.provingGround.block5Note
          : ''
      break
    case 'block6':
      blockNote =
        proving.provingGround && proving.provingGround.block6Note
          ? proving.provingGround.block6Note
          : ''
      break
    case 'block7':
      blockNote =
        proving.provingGround && proving.provingGround.block7Note
          ? proving.provingGround.block7Note
          : ''
      break
    case 'block8':
      blockNote =
        proving.provingGround && proving.provingGround.block8Note
          ? proving.provingGround.block8Note
          : ''
      break
    case 'block9':
      blockNote =
        proving.provingGround && proving.provingGround.block9Note
          ? proving.provingGround.block9Note
          : ''
      break
    case 'block10':
      blockNote =
        proving.provingGround && proving.provingGround.block10Note
          ? proving.provingGround.block10Note
          : ''
      break
    default:
      break
  }

  return blockNote.length > 0 ? (
    <Section label={t('model.proving.documents.note')}>
      <Label>{blockNote}</Label>
    </Section>
  ) : (
    <></>
  )
}
